import React, { useEffect, useState, useContext, useCallback } from "react";
import undrawProfile from "../img/undraw_profile.svg";
import serviceIcon from "../img/service.png";
import { getuserInfo, getUserActivity } from "../store/actions/userActions";
import { useDispatch, useSelector } from "react-redux";
import {
  concatenateAndTruncate,
  truncateText,
} from "../../utils/application-helper";
import { NavLink } from "react-router-dom";
import ImagePopup from "./ImagePopup";
import axiosHttp from "../config/axios.interceptor";
import { AppContext } from "../contexts/AppContext";
import Loader from "./Loader";

const LeftProfileCard = ({
  toggleSettingsHandler,
  showSettings,
  isOtherUser,
  otherUser,
  loading,
}) => {
  const dispatch = useDispatch();
  const { userData, followersCount, postsCount } = useSelector(
    (state) => state.user
  );
  const [userActivity, setUserActivity] = useState(null);
  const [showImage, setShowImage] = useState("");
  // const [otherUser, setOtherUser] = useState({});
  const appContext = useContext(AppContext);

  useEffect(() => {
    dispatch(getuserInfo());
  }, []);

  useEffect(() => {
    dispatch(getUserActivity(userData.userId));
  }, [userData]);

  // useEffect(() => {
  //   if (isOtherUser) {
  //     getProfile();
  //   } else {
  //   }
  // }, [isOtherUser, appContext.openModal]);

  // const getProfile = () => {
  //   axiosHttp
  //     .get("profile/" + isOtherUser)
  //     .then((apiResponse) => {
  //       if (apiResponse.status === 200) {
  //         setOtherUser(apiResponse?.data?.data ?? {});
  //       } else {
  //         appContext.updateNotificationState({
  //           show: true,
  //           type: "error",
  //           message: "Error, please try after sometime.",
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       if (error.response.status === 429) {
  //         appContext.updateNotificationState({
  //           show: true,
  //           message: errorResponseMessage(error),
  //           type: "error",
  //         });
  //         authContext.logout();
  //       }
  //       if (error.response.status === 400) {
  //         appContext.updateNotificationState({
  //           show: true,
  //           message: errorResponseMessage(error),
  //           type: "error",
  //         });
  //       }
  //       appContext.updateNotificationState({
  //         show: true,
  //         type: "error",
  //         message: "Error, please try after sometime.",
  //       });
  //     });
  // };

  useEffect(() => {
    setUserActivity({
      following:
        followersCount?.followingCount || followersCount?.following || 0,
      post: postsCount || 0,
    });
  }, [followersCount?.followingCount]);

  // const getOtherUserImage = () => {
  //   if (isOtherUser) {
  //     if (otherUser?.picUrl) {
  //       return otherUser?.picUrl;
  //     } else {
  //       return undrawProfile;
  //     }
  //   } else {
  //     if (userData?.picUrl) {
  //       return userData?.picUrl;
  //     } else {
  //       return undrawProfile;
  //     }
  //   }
  // };

  const isSMEProfile = useCallback(() => {
    if (!otherUser) {
      if (userData?.offerService) {
        return true;
      } else {
        return false;
      }
    }
    if (otherUser) {
      if (otherUser?.offerService) {
        return true;
      } else {
        return false;
      }
    }
  }, [otherUser, userData?.offerService, otherUser?.offerService]);

  return loading ? (
    <Loader />
  ) : (
    <>
      <div className="card card-one">
        <div className="card-body  mb-3">
          {/* <img
            src={userData?.bannerUrl ? userData.bannerUrl : profileBackground}
            className="img-fluid postion-absolute banner-url"
          /> */}
          <div className="text-center">
            <div className="sme-profile">
              <img
                className={`img-profile rounded-circle img-pos ml-1 cursor-pointer ${
                  isSMEProfile() ? "sme-service" : null
                }`}
                src={
                  isOtherUser
                    ? otherUser?.isBlockedUser
                      ? undrawProfile
                      : otherUser?.picUrl
                      ? otherUser.picUrl
                      : undrawProfile
                    : userData?.picUrl
                    ? userData.picUrl
                    : undrawProfile
                }
                onClick={() => {
                  // userData?.picUrl ? setShowImage(userData?.picUrl) : null;
                  isOtherUser
                    ? otherUser?.picUrl
                      ? setShowImage(otherUser.picUrl)
                      : null
                    : userData?.picUrl
                    ? setShowImage(userData.picUrl)
                    : null;
                }}
              />
              {isSMEProfile() && <div className="sme-profile-icon">SME</div>}
            </div>
            <div>
              <NavLink
                to={`${
                  isOtherUser
                    ? `../${otherUser?.userName}`
                    : `../${userData?.userName}`
                }`}
              >
                <p className="profile-name mb-2 ml-3 mt-3 text-center">
                  {isOtherUser
                    ? otherUser?.fName || otherUser?.lName
                      ? `${otherUser?.fName || ""} ${otherUser?.lName || ""}`
                      : otherUser?.userName || ""
                    : userData?.fName || userData?.lName
                    ? `${userData?.fName || ""} ${userData?.lName || ""}`
                    : userData?.userName || ""}
                </p>
                <div className="tool-tip">
                  <p className="ml-3 text-center info-icon">
                    {isOtherUser && otherUser?.experiences
                      ? truncateText(otherUser.experiences, 30)
                      : ""}
                    {!isOtherUser && userData?.experiences
                      ? truncateText(userData.experiences, 30)
                      : ""}
                  </p>
                  <div className="tooltiptext profile-tooltip">
                    {" "}
                    {isOtherUser && otherUser?.experiences
                      ? otherUser.experiences
                      : ""}
                    {!isOtherUser && userData?.experiences
                      ? userData.experiences
                      : ""}
                  </div>
                </div>
              </NavLink>
            </div>
          </div>
          <div className="d-flex">
            {/* <span
              className="ml-4 cursor-pointer"
              onClick={toggleSettingsHandler}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                className={showSettings ? "arrow-rotate" : ""}
              >
                <path
                  d="M2.60727 4.64914C2.76259 4.49381 3.00564 4.47969 3.17692 4.60678L3.22599 4.64914L6.99996 8.42291L10.7739 4.64914C10.9293 4.49381 11.1723 4.47969 11.3436 4.60678L11.3927 4.64914C11.548 4.80446 11.5621 5.04751 11.435 5.21879L11.3927 5.26786L7.30932 9.35119C7.154 9.50651 6.91094 9.52063 6.73967 9.39355L6.6906 9.35119L2.60727 5.26786C2.43641 5.097 2.43641 4.81999 2.60727 4.64914Z"
                  fill="black"
                />
              </svg>
            </span> */}
          </div>
          {/* <div className="row">
            <div className="col-md-6">
              <p className="text-center mb-2">Post</p>
              <p className="text-center">{userActivity?.post || 0}</p>
            </div>
            <div className="col-md-6">
              <p className="text-center mb-2">Followers</p>
              <p className="text-center">{userActivity?.following || 0}</p>
            </div>
          </div> */}
        </div>
      </div>
      {/* {isMenu && showMenu && <SpaceMenu />} */}
      {showImage !== "" && (
        <ImagePopup url={showImage} setShowImage={setShowImage} />
      )}
    </>
  );
};

export default LeftProfileCard;
